import script from "./normal-attribute.vue?vue&type=script&setup=true&lang=ts"
export * from "./normal-attribute.vue?vue&type=script&setup=true&lang=ts"

import "./normal-attribute.vue?vue&type=style&index=0&id=1cc4f4ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cc4f4ca"]])

export default __exports__